const webBaseUrl = process.env.REACT_APP_API_URL || 'https://lk-api.eskso.ru/HPA/API/1_0/';
const webProxyUrl = process.env.REACT_APP_WEB_PROXY_URL || 'https://lk.eskso.ru';

export const settings = {
  baseUrl: webBaseUrl,
  webProxyUrl: webProxyUrl,
};
